// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warehouse-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
  column-gap: 0.625rem;
  row-gap: 0.625rem;
}
.warehouse-container .listing-header .title-div {
  font-weight: bold;
  font-size: 1.75rem;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.warehouse-container .form-container {
  padding: 1.5625rem 0;
}
.warehouse-container .warehouse-input-wrap {
  display: flex;
  place-content: space-between;
}
.warehouse-container .warehouse-input-wrap .form-inputs {
  padding-bottom: 0.75rem;
  position: relative;
}
.warehouse-container .warehouse-input-wrap .form-inputs ion-item .country-code {
  display: none;
}
.warehouse-container .warehouse-input-wrap .form-inputs ion-textarea {
  margin-top: 0;
}
.warehouse-container .warehouse-input-wrap .form-inputs ion-item.item-has-value .country-code,
.warehouse-container .warehouse-input-wrap .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.warehouse-container .warehouse-input-wrap .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}
.warehouse-container .warehouse-input-wrap .input-div {
  width: 49.2%;
}
.warehouse-container .warehouse-input-wrap .width-100 {
  width: 100%;
}
.warehouse-container .warehouse-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1.125rem;
}
.warehouse-container .warehouse-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.warehouse-container .warehouse-bottom-container .cancel:hover {
  font-weight: 600;
}
.warehouse-container .warehouse-bottom-container .warehouse-button ion-button {
  --background: var(--ion-color-primary);
  width: 130px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}
.warehouse-container .spinner-btn {
  color: var(--ion-color-primary-white);
  position: absolute;
  right: 81px;
  top: 0.625rem;
}

.arabic-class {
  direction: rtl !important;
}
.arabic-class ion-label {
  -webkit-transform-origin-x: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-edit-warehouse/add-edit-warehouse.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,iBAAA;AAAF;AAEE;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;AAAH;AAIC;EACC,oBAAA;AAFF;AAKC;EACC,aAAA;EACA,4BAAA;AAHF;AAKE;EACC,uBAAA;EACA,kBAAA;AAHH;AAMI;EACC,aAAA;AAJL;AAQG;EACC,aAAA;AANJ;AAWI;;EACC,aAAA;AARL;AAYG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AAVJ;AAcE;EACC,YAAA;AAZH;AAeE;EACC,WAAA;AAbH;AAiBC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAfF;AAiBE;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAfH;AAiBG;EACC,gBAAA;AAfJ;AAoBG;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAlBJ;AAuBC;EACC,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AArBF;;AAyBA;EACC,yBAAA;AAtBD;AAwBC;EACC,iCAAA;AAtBF","sourcesContent":[".warehouse-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\t\tcolumn-gap: 0.625rem;\n\t\trow-gap: 0.625rem;\n\n\t\t.title-div {\n\t\t\tfont-weight: bold;\n\t\t\tfont-size: 1.75rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n\n\t.form-container {\n\t\tpadding: 1.5625rem 0;\n\t}\n\n\t.warehouse-input-wrap {\n\t\tdisplay: flex;\n\t\tplace-content: space-between;\n\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\t\t\tposition: relative;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-textarea {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\n\t\t.input-div {\n\t\t\twidth: 49.2%;\n\t\t}\n\n\t\t.width-100 {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.warehouse-bottom-container {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tpadding-top: 1.125rem;\n\n\t\t.cancel {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t.warehouse-button {\n\t\t\tion-button {\n\t\t\t\t--background: var(--ion-color-primary);\n\t\t\t\twidth: 130px;\n\t\t\t\theight: 46px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\tline-height: 1.125rem;\n\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t--box-shadow: none;\n\t\t\t\t--border-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.spinner-btn {\n\t\tcolor: var(--ion-color-primary-white);\n\t\tposition: absolute;\n\t\tright: 81px;\n\t\ttop: 0.625rem;\n\t}\n}\n\n.arabic-class {\n\tdirection: rtl !important;\n\n\tion-label {\n\t\t-webkit-transform-origin-x: right;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
